import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { qaSectionStyles } from '../../styles/qaStyles';

/**
 * QA 섹션 헤더 컴포넌트
 * @returns {JSX.Element} - QA 헤더
 */
const QAHeader = () => {
  const { t } = useTranslation();

  return (
    <Typography 
      id="qa-title"
      variant="h6" 
      sx={qaSectionStyles.title}
    >
      {t('analyze.chatTitle')}
    </Typography>
  );
};

export default QAHeader; 